import {ROLES} from '../constants/allConstants';

const CONTRACTOR_TAG_ELEMENTS = {
  viewPage: 'viewPage',
  addTagButton: 'addTagButton',
};

/**
 * Contractor tags (tagJobs) belong to the contractor's own company, so both contractor
 * roles manage them, not just the company admin.
 *
 * Kept separate from contractorUserPageRules, which the Users page and the Users nav item
 * also use: widening that rule to CONTRACTOR would have handed every contractor the user
 * management page along with it. The backend agrees with this split - getTagCompanyScope()
 * scopes tag reads and writes by companyId alone and never looks at the role.
 */
const contractorTagJobRules = Object.freeze({
  [CONTRACTOR_TAG_ELEMENTS.viewPage]: {
    policyName: undefined,
    contractorAccess: true,
    contractorPermissions: [ROLES.COMPANY_ADMIN, ROLES.CONTRACTOR],
  },

  /**
   * policyName and impersonateOnly are carried over from the rule this replaced
   * (contractorUserPageRules.addUserButton) deliberately. They decide only the iPermit
   * staff branch, where the button still needs an impersonated company to attach the tag
   * to, and swapping in a tag policy would take the button away from staff who hold
   * user.invite but not inspection.manageTags. Contractors never reach that branch:
   * NewPermissionGate answers on contractorPermissions above and returns first.
   */
  [CONTRACTOR_TAG_ELEMENTS.addTagButton]: {
    policyName: 'user.invite',
    contractorAccess: true,
    contractorPermissions: [ROLES.COMPANY_ADMIN, ROLES.CONTRACTOR],
    impersonateOnly: true,
  },
});

export {contractorTagJobRules, CONTRACTOR_TAG_ELEMENTS};
